<template>
  <div class="animated fadeIn">
    <div>
      <b-modal centered v-model="active" label="Delete" v-if="agentToDelete">
        <div>Are you sure you want to delete {{agentToDelete.name}}?</div>
        <div slot="modal-footer">
          <b-btn ref="myModalRef" variant="danger" @click="handleConfirm">Confirm</b-btn>
          <b-btn @click="handleCancel">Cancel</b-btn>
        </div>
      </b-modal>
    </div>
    <div class="agent-list">

      <b-card header-tag="header">
        <div slot="header">
          <strong>Agents</strong>
          <div class="card-actions">
            <b-dropdown variant="link" size="sm" no-caret>
              <template slot="button-content">
                <i class="fa fa-ellipsis-v fa-lg"></i>
              </template>
              <b-dropdown-header>Agent</b-dropdown-header>
              <b-dropdown-item to="/agents/add">Add Agent</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <b-row class="my-4" align-v="center">
          <b-col cols="12" lg="6" class="my-2">
            <b-form-group class="mb-0">
              <b-input-group>
                <b-form-input
                  :value="filter.q"
                  :disabled="isBusy"
                  @blur.native="updateSearch"
                  @keyup.native="updateSearchOnEnterKey"
                  placeholder="Type to Search"/>
                <b-input-group-append>
                  <b-btn :disabled="!filter.q" @click="filter.q = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <input type="hidden" id="agentUrl" :value="agentUrl"/>
        <b-table
          ref="agentTable"
          stacked="lg"
          :items="agents"
          :outlined="true"
          head-variant="light"
          show-empty
          responsive
          :busy.sync="isBusy"
          :fields="fields"
          :filter="filter.q"
          hover>
          <template slot="name" slot-scope="row">
            <h6>{{row.item.name}}</h6>
            <div class="my-2">
              <div v-if="row.item.email">
                <a :href="'mailto:' + row.item.email" target="_blank">
                  <small>{{row.item.email}}</small>
                </a>
              </div>
              <div v-if="row.item.secondary_email">
                <a :href="'mailto:' + row.item.secondary_email" target="_blank">
                  <small>{{row.item.secondary_email}}</small>
                </a>
              </div>
            </div>
          </template>
          <template slot="address" slot-scope="row">
            <address>
              <small>
                {{row.item.building}} - {{row.item.street}}, <br>
                {{row.item.city}}, {{row.item.postcode}} ,{{row.item.country}}
              </small>
            </address>
          </template>
          <template slot="contact" slot-scope="row">
            <small class="text-muted text-uppercase font-weight-bold">
              <div class="my-2" v-if="row.item.phone">
                phone: <a :href="'tel:' + row.item.phone">{{row.item.phone}}</a>
              </div>
              <div class="my-2" v-if="row.item.mobile">
                mobile: <a :href="'tel:' + row.item.mobile">{{row.item.mobile}}</a>
              </div>
              <div class="my-2" v-if="row.item.fax">
                fax: {{row.item.fax}}
              </div>
            </small>
          </template>
          <template slot="more" slot-scope="row">
            <b-dropdown variant="link" size="sm" no-caret>
              <template slot="button-content">
                <i class="fa fa-ellipsis-h fa-lg"></i>
              </template>
              <b-dropdown-header>{{row.item.name}}</b-dropdown-header>
              <b-dropdown-item :to="'/agents/' + row.item.id + '/edit'">Edit Agent</b-dropdown-item>
              <!--              <b-dropdown-divider></b-dropdown-divider>-->
              <b-dropdown-item @click="copyBookingUrl(row.item.slug)">Copy Booking URL</b-dropdown-item>
              <b-dropdown-item :to="'/agents/' + row.item.id + '/bookings'">View Bookings</b-dropdown-item>
              <b-dropdown-item-button @click="confirmDelete(row.item)">Delete Agent</b-dropdown-item-button>
            </b-dropdown>
          </template>
        </b-table>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Agents',
  data () {
    return {
      isBusy: false,
      agentToDelete: null,
      active: false,
      filter: {
        q: '',
        asc: true
      },
      fields: [
        { key: 'name', label: 'Agent', sortable: true, sortDirection: 'desc' },
        { key: 'address', label: 'Address' },
        { key: 'contact', label: 'Contact' },
        { key: 'more', label: '' }
      ],
      agentUrl: ''
    }
  },
  methods: {
    updateSearch (e) {
      this.filter.q = e.target.value
    },
    updateSearchOnEnterKey (e) {
      if (e.keyCode === 13) {
        e.preventDefault()
        this.filter.q = e.target.value
      }
    },
    copyBookingUrl (slug) {
      let toCopyField = document.querySelector('#agentUrl')
      toCopyField.setAttribute('type', 'text')
      toCopyField.value = 'https://booking.victory-garage.com/agents/' + slug
      toCopyField.select()

      try {
        let successful = document.execCommand('copy')
        let msg = successful ? 'URL copied to clipboard.' : 'Oops, unable to copy'
        alert(msg)
      } catch (err) {
        alert('Oops, unable to copy')
      }

      toCopyField.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    confirmDelete (agent) {
      this.agentToDelete = agent
      this.active = true
    },
    handleConfirm () {
      let xhr = this.$store.dispatch('agents/destroy', this.agentToDelete.id)
      xhr.then(this.handleDeleteSuccess).catch(this.handleDeleteFail)
    },
    handleCancel () {
      this.active = false
    },
    handleDeleteSuccess () {
      this.active = false
      this.getAgents()
    },
    handleDeleteFail () {
      this.isBusy = false
    },
    getAgents () {
      this.isBusy = true
      let xhr = this.$store.dispatch('agents/index')

      xhr.then(
        () => {
          this.isBusy = false
        },
        () => {
          this.isBusy = false
        }
      )
    }
  },
  computed: {
    ...mapGetters(
      'agents',
      [
        'agents'
      ]
    )
  },
  created () {
    this.getAgents()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/agents/Index.vue